"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionList = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const React = __importStar(require("react"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const StyledList = styled_1.default.ul `
	margin: 0;
	padding: 0;
	list-style: none;
`;
const StyledListItem = styled_1.default.li `
	padding: ${merlin_theme_1.default.layout.spacing.smallest} ${merlin_theme_1.default.layout.spacing.smallest};
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	outline: none;

	/*

	HIGHLIGHTING & BORDERS

	All elements have a border at all times to avoid shifting positions when it toggles on/off.
	The bottom border is removed so that siblings' borders overlap neatly, and the top border is
	used as a delimiter.  The delimeter border is hidden before the first, and after the last
	option.

	When an option is targeted, the background and border colours change.  If the option has a
	sibling below it, that sibling's top border needs to be changed also.

	*/

	border-top: 1px solid ${merlin_theme_1.default.colours.delimiter.default};

	&:hover,
	&:active,
	&:focus {
		border-color: ${merlin_theme_1.default.colours.highlight.default};
		background-color: ${merlin_theme_1.default.colours.background.default};
	}

	/* select the next sibling */
	&:hover + &,
	&:active + &,
	&:focus + & {
		border-top-color: ${merlin_theme_1.default.colours.highlight.default};
	}

	/* borders touching container are always transparent */
	&:last-child {
		border-bottom: 1px solid transparent;
	}
	&:first-of-type {
		border-color: transparent;
	}

	/* RHS ARROW */

	&::after {
		content: '\\e904';
		font-family: ${merlin_theme_1.default.typography.fonts.icons};
		color: ${merlin_theme_1.default.colours.text.light};
		font-size: 1.375rem;
		line-height: 1;
	}

	&:hover::after,
	&:focus::after {
		color: ${merlin_theme_1.default.colours.text.medium};
	}
`;
const StyledListText = styled_1.default.span `
	display: block;
	flex-grow: 1;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;
const buildOnKeyDown = (callbacks) => (e) => {
    if (e.key in callbacks) {
        e.preventDefault();
        callbacks[e.key]();
    }
};
function OptionList({ options, onSelect, priorRef }) {
    if (!options || !options.length)
        return null;
    const optionRefs = [];
    const arrowKeyCallbacks = (index) => ({
        'ArrowUp': () => {
            const prev = index === 0 && priorRef ? priorRef : optionRefs[index - 1];
            if (prev && prev.current)
                prev.current.focus();
        },
        'ArrowDown': () => {
            const next = optionRefs[index + 1];
            if (next && next.current)
                next.current.focus();
        }
    });
    const Option = ({ option, index }) => {
        const ref = React.useRef(null);
        optionRefs.push(ref);
        return React.createElement(StyledListItem, { tabIndex: 0, ref: ref, onClick: onSelect ? () => onSelect(option) : undefined, 
            // this must be onKeyDown to work with arrow keys
            onKeyDown: buildOnKeyDown(Object.assign(Object.assign({}, (onSelect && { 'Enter': () => onSelect(option) })), arrowKeyCallbacks(index))) },
            React.createElement(StyledListText, null, option.label));
    };
    return React.createElement("div", { className: "option-list" },
        React.createElement(StyledList, null, (options || []).map((o, i) => React.createElement(Option, { key: i, option: o, index: i }))));
}
exports.OptionList = OptionList;
//# sourceMappingURL=OptionList.js.map